import styled from "styled-components";
import { DESKTOP_MEDIA_QUERY } from "../constants";
import images from "../images";

export const Wrapper = styled.div``;

export const Title = styled.div`
  margin: 23px;
  font-size: 16px;
  font-weight: 600;
  color: #0000ff;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 48px;
  }
`;

export const Subtitle = styled.div`
  margin: 0 23px;
  font-size: 14px;
  font-weight: 600;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 36px;
  }
`;

export const TextBlock = styled.div`
  position: relative;
  padding: 57px 28px;
  margin: 40px 25px 50px;
  border: 2px solid #ff0000;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 600;

  ${DESKTOP_MEDIA_QUERY} {
    max-width: 1041px;
    padding: 76px 54px;
    margin: 88px auto 60px;
    font-size: 36px;
  }
`;

export const Time = styled.div`
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: 600;
  color: #0000ff;
  text-align: center;

  ${DESKTOP_MEDIA_QUERY} {
    margin-bottom: 30px;
    font-size: 36px;
  }
`;

export const IconLeft = styled.div`
  width: 59px;
  height: 76px;

  position: absolute;
  top: -38px;
  left: 52px;

  background-image: url(${images.intro_icon_left.src});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 55px;

  ${DESKTOP_MEDIA_QUERY} {
    width: 90px;
    height: 120px;

    top: -60px;
    left: 190px;

    background-size: 85px;
  }
`;

export const IconRight = styled(IconLeft)`
  left: auto;
  right: 52px;

  background-image: url(${images.intro_icon_right.src});

  ${DESKTOP_MEDIA_QUERY} {
    top: -60px;
    left: auto;
    right: 190px;
  }
`;

export const IconBottom = styled(IconLeft)`
  top: auto;
  left: 50%;
  bottom: -38px;
  margin-left: -30px;

  background-image: url(${images.intro_icon_bottom.src});

  ${DESKTOP_MEDIA_QUERY} {
    top: auto;
    bottom: -60px;
    left: 50%;
    margin-left: -45px;
  }
`;
